import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onCreateFaculty,
  onDeleteFaculty,
  onGetFaculty,
  onGetPagedAllFaculties,
  onUpdateFaculty,
} from '../../../app/modules/system-definitions/components/faculties/core/_requests'
import {onGetUniversities} from '../../../app/services/dataForComboBox/dataForComboBoxService'

interface FacultyState {
  faculties: any
  faculty: any
  universities: any
  isLoading: boolean
}
const initialState = {
  faculties: [],
  universities: [],
  faculty: null,
  isLoading: true,
} as FacultyState

export const fetchUniversities = createAsyncThunk('faculty/fetchUniversities', async () => {
  const data: any = await onGetUniversities()
  return data.data.result
})

export const fetchFaculties = createAsyncThunk('faculty/fetchFaculties', async (param: any) => {
  const data: any = await onGetPagedAllFaculties(param)
  return data.data.result
})

export const fetchFaculty = createAsyncThunk('faculty/fetchFaculty', async (param: any) => {
  const data: any = await onGetFaculty(param)
  return data.data.result
})

export const updateFaculty = createAsyncThunk('faculty/updateFaculty', async (param: any) => {
  const data: any = await onUpdateFaculty(param)
  return data.data
})

export const createFaculty = createAsyncThunk('faculty/createFaculty', async (param: any) => {
  const data: any = await onCreateFaculty(param)
  return data.data
})

export const deleteFaculty = createAsyncThunk('faculty/deleteFaculty', async (param: any) => {
  const data: any = await onDeleteFaculty(param)
  return data.data
})

const facultySlice = createSlice({
  name: 'faculty',
  initialState,
  reducers: {
    clearFaculties: (state) => {
      state.faculties = []
    },
    clearFaculty: (state) => {
      state.faculty = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFaculties.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchFaculties.fulfilled, (state: any, action) => {
      state.faculties = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchFaculties.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchFaculty.fulfilled, (state: any, action) => {
      state.faculty = action.payload
    })
    builder.addCase(fetchUniversities.fulfilled, (state: any, action) => {
      state.universities = action.payload.items
    })
  },
})

export const {clearFaculties, clearFaculty, activateLoading} = facultySlice.actions

export default facultySlice.reducer
